/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to auto format events" |
*
* @param {Auto_Format_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_failed = /** @type {((inputs?: Auto_Format_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l’auto-formatage des événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Formatierung der Ereignisse fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile formattare automaticamente gli eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось выполнить автоматическое форматирование событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron formatear automáticamente los eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式化事件失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの自動フォーマットに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट्स को ऑटो फॉर्मेट करने में विफलता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao formatar eventos automaticamente")
	return /** @type {LocalizedString} */ ("Failed to auto format events")
});